import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import InvestSection from '../../Components/InvestSection';

export default function InvestInProject() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='invest-in-project-page'>
      <Helmet>
        <title>Starlife: Invest in Project</title>
        <meta
          name='description'
          content='Explore investment opportunities with Starlife Group. Invest in luxury real estate projects and benefit from high returns and exclusive opportunities.'
        />
        <meta
          name='keywords'
          content='Invest in real estate, Starlife Group investments, Luxury real estate investments, High return real estate, Real estate opportunities, Investment properties Miami'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <InvestSection />
    </div>
  );
}
